import { Injectable } from '@angular/core';

import { AnalyticsEvent } from '../../../Domain/Model/analytics.event';
import { FirebaseErrorLogger } from '../../../Domain/Port/firebase-error.logger';

/**
 * A concrete implementation of FirebaseErrorLogger that logs errors to the console.
 * This is the default error logger used by the analytics module.
 */
@Injectable({
    providedIn: 'root'
})
export class FirebaseConsoleErrorLogger extends FirebaseErrorLogger {
    /**
     * Logs an error that occurred during event logging to the console.
     *
     * @param event - The analytics event that was being logged when the error occurred
     * @param error - The error that occurred during event logging
     * @returns A promise that resolves when the error has been logged
     */
    async logError(event: AnalyticsEvent, error: unknown): Promise<void> {
        console.error('Error logging analytics event:', {
            eventName: event.name,
            eventParams: event.params,
            error
        });
    }
}
